<template>
  <q-page class="q-pa-md bg-grey-2">
    <q-card class="shadow-2 rounded-borders">
      <q-card-section class="bg-primary text-white row items-center justify-between q-py-md">
        <div class="text-h6 text-weight-bold row items-center">
          <q-icon name="settings" class="q-mr-sm" size="sm" />
          Configuración General
        </div>
      </q-card-section>

      <q-card-section class="q-pa-md">
        <q-form class="q-gutter-y-md">
          <div class="row q-col-gutter-md">
            <div class="col-12 col-sm-6">
              <q-input
                v-model="ruc"
                label="RUC Empresa *"
                outlined
                dense
              />
            </div>
            <div class="col-12 col-sm-6">
              <q-input
                v-model="nombre"
                label="Nombre Empresa *"
                outlined
                dense
              />
            </div>
          </div>

          <div class="row q-col-gutter-md">
            <div class="col-12 col-sm-6">
              <q-input
                v-model="direccion"
                label="Dirección"
                outlined
                dense
              />
            </div>
            <div class="col-12 col-sm-6">
              <q-input
                v-model="telefono"
                label="Teléfono"
                outlined
                dense
              />
            </div>
          </div>

          <div class="row q-col-gutter-md">
            <div class="col-12 col-sm-6">
              <q-file
                v-model="file"
                label="Imagen / Logo"
                outlined
                dense
              >
                <template v-slot:prepend>
                  <q-icon name="attach_file" />
                </template>
              </q-file>
            </div>
          </div>
        </q-form>
      </q-card-section>
    </q-card>
  </q-page>
</template>

<script>
import axios from 'axios';
export default {
  name: "ConfiguracionPage",
  data() {
    return {
      file: null,
      ruc: '',
      nombre: '',
      direccion: '',
      bd: '',
      telefono: ''
    };
  },
  created() {
    this.DatosEmpresa();
  },
  methods: {
    DatosEmpresa() {
      axios({
        method: 'get',
        url: 'Entidad/GetEntidad',
      })
        .then(response => {
          if (response.data) {
            this.nombre = response.data.nombre || '';
            this.ruc = response.data.ruc || '';
            this.direccion = response.data.direccion || '';
            this.telefono = response.data.tel1 || '';
          }
        })
        .catch(err => console.error(err));
    },
  }
};
</script>